import { Step, State, Action } from '../../../types/tour';

const goTo = (
  current: number,
  { last, first }: { last: number; first: number },
) => ({
  current,
  showNext: current !== last,
  showPrev: current !== first,
});

const completeStep = (
  stepToComplete: number,
  parentStep?: number,
  steps?: Step[],
) => {
  if (!steps) return [];
  const complete = (step: Step, index: number) => {
    return index === stepToComplete
      ? {
          ...step,
          completed: true,
        }
      : step;
  };

  if (parentStep) {
    return steps?.map((step: Step, index: number) => {
      if (index === parentStep) {
        const updatedSubsteps = step?.steps?.map(complete);

        const isMissingSubsteps = updatedSubsteps?.reduce((acc, curr) => {
          if (acc) return true;
          if (!curr.completed && !curr.optional) {
            return true;
          }
          return false;
        }, false);

        return {
          ...step,
          steps: step?.steps?.map(complete),
          completed: !isMissingSubsteps,
        };
      }
      return step;
    });
  }

  return steps?.map(complete);
};

export const getStartedReducer = (
  { steps, current, ...state }: State,
  action: Action,
): State => {
  switch (action.type) {
    case 'setComplete':
      return {
        ...state,
        steps: completeStep(action.step, action.parentStep, steps),
        current,
      };
    case 'goTo':
      return {
        ...state,
        steps,
        ...goTo(action.to, state),
      };

    case 'goNext':
      return {
        ...state,
        steps,
        ...goTo(current + 1, state),
      };
    case 'goPrev':
      return {
        ...state,
        steps,
        ...goTo(current - 1, state),
      };
    case 'showModal':
      return {
        ...state,
        steps,
        current,
        modal: {
          content: action.modal.content,
          title: action.modal.title,
        },
      };
    case 'hideModal':
      return {
        ...state,
        steps,
        current,
        modal: undefined,
      };
    default:
      throw new Error(`Invalid action`);
  }
};
